import React, {useMemo} from 'react'
import Link from 'next/link'
import {equalString} from '@util/strings'
import {useRouter} from 'next/router'
import Logo from '@svg/gnb/img_nav_logo.svg'
import LogoWhite from '@svg/gnb/img_nav_logo_white.svg'
import {DarkModeStore} from '@store/DarkmodeStore'
import {createLog} from '@util/logs'
import {getLinkUrl, URL_HOME} from '@constant/url'

interface IProps {
    overlayWhite?: boolean
    className?: string
    logoType?: 'default' | 'white'
}

const NavTitle: React.FC<IProps> = ({className, logoType}) => {
    const router = useRouter()
    const isRootPath = useMemo(
        () =>
            equalString(router?.pathname, '/') ||
            equalString(router?.pathname, '/home') ||
            equalString(router?.pathname, '/token') ||
            equalString(router?.pathname, '/landing/pro'),
        [router],
    )
    const {isCheckDark, isDark} = DarkModeStore()

    return (
        <div className={`flex ${className} overflow-hidden items-center flex-none`}>
            <Link
                href={getLinkUrl(URL_HOME)}
                onClick={() => createLog('event', 'navigation_click_home')}
                className={`cursor-pointer ${!isRootPath && 'sm:hidden'}`}>
                {logoType === 'white' || (isCheckDark && isDark) ? (
                    <LogoWhite className={`w-[165px]`} />
                ) : (
                    <Logo className={`w-[165px]`} />
                )}
            </Link>
        </div>
    )
}

export default NavTitle
